var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTlsFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h90.633v45H0V0Z",
    fill: "#CB000F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.281 0 45 22.561 45 22.561L0 45V0Z",
    fill: "#F8C00C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c.185 0 29.936 22.561 29.936 22.561L0 45V0Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.497 26.209-5.335-1.186-2.725 4.64-.439-5.247-5.335-1.169 4.825-2.188-.29-5.212 3.533 3.814 4.87-2.224-2.54 4.747 3.445 4.025h-.009Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTlsFlag);
export default __webpack_public_path__ + "static/media/tls-flag.424205e5516ed8efdba0f3b167664067.svg";
export { ForwardRef as ReactComponent };